import Model from '@/models/Model.js';

export default class LtiResourceLinkActivityTemplate extends Model {
    static entity = 'lti_resource_link_activity_templates';

    static modelName = 'LtiResourceLinkActivityTemplate';

    static fields() {
        return {
            id: this.attr(null),
            content: this.attr(null),
            lti_resource_link_id: this.attr(null),

            ...super.fields(),
        };
    }
}
